<template>
  <div class="dynamic-item" v-if="data" @click="bindClick">
    <div class="d-top" v-if="data.base.user">
      <div class="d-avatar-c">
        <img class="d-avatar" :src="data.base.user.u_img" alt="" />
        <img
          class="d-flag"
          v-if="data.base.user.label_data"
          :src="data.base.user.label_data.url"
          alt=""
        />
      </div>
      <div class="d-top-c">
        <div class="nickname">{{ data.base.user.u_name }}</div>
        <div class="alias" v-if="data.base.user.label_data">{{
          data.base.user.label_data.alias
        }}</div>
      </div>
      <!-- <div class="focus-btn" :class="{ 'focus-btn-active': data.base.user.is_follow }"><span
                    class="iconfont icon-jiahao" v-if="!data.base.user.is_follow"></span>{{ data.base.user.is_follow ? '已关注'
                        : '关注' }}
            </div> -->
    </div>
    <div class="d-text">
      <span>{{ data.base.desc }}</span>
    </div>
    <div class="image-container">
      <div class="image-list">
        <img
          class="image-item"
          :class="{ 'image-item-one': data.base.image_list.length == 1 }"
          @click="previewImage(data.base.image_list, index1)"
          v-for="(item1, index1) in data.base.image_list"
          :key="index1"
          :src="item1.url"
          v-show="index1 < 3"
        />
      </div>
      <div class="image-num" v-if="data.base.image_list.length >= 3"
        >+{{ data.base.image_list.length }}
      </div>
    </div>
    <div class="tag-list"
      ><span
        class="tag-item"
        v-for="(item1, index1) in data.detail.topic_data"
        :key="index1"
        >#{{ item1.topic }}</span
      >
    </div>
    <!-- <div class="operate-list">
            <div class="operate-item"><span class="iconfont icon-comments-fill-8"></span><span>{{
                data.base.comment_info.number }}</span>
            </div>
            <div class="operate-item" :class="{ 'operate-item-active': data.base.like_info.is_like }"><span
                    class="iconfont icon-favorites-fill-2beifen"></span><span>{{ data.base.like_info.number }}</span>
            </div>
        </div> -->
  </div>
</template>
<script>
import { ImagePreview } from 'vant'
export default {
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {}
  },
  methods: {
    previewImage(urls, index) {
      let images = urls.map((item) => {
        return item.url
      })
      ImagePreview({
        images: images,
        startPosition: index
      })
    },
    bindClick() {
      let url =
        '/ugcDetails?tabType=' +
        this.data.detail.tab_type +
        '&id=' +
        this.data.detail.id
      this.$betterwe.jumpRoute(url)
    }
  }
}
</script>
<style lang="scss" scoped>
.dynamic-item {
  background: #ffffff;
  border-radius: 10px;
  margin-bottom: 16px;
  padding: 15px 16px;

  .d-top {
    display: flex;
    align-items: center;
    margin-bottom: 12px;

    .d-avatar-c {
      position: relative;
      width: 36px;
      height: 36px;
      margin-right: 10px;

      .d-avatar {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 6px;
      }

      .d-flag {
        position: absolute;
        right: 0;
        bottom: 0;
        transform: translate(50%, 0%);
        width: 15px;
        height: 15px;
      }
    }

    .d-top-c {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;

      .nickname {
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.8);
        line-height: 17px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .alias {
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        color: rgba(0, 0, 0, 0.6);
        line-height: 17px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    .focus-btn {
      width: 64px;
      height: 25px;
      line-height: 25px;
      text-align: center;
      background: rgba(98, 54, 255, 0.06);
      border-radius: 13px;
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      color: #6236ff;

      .iconfont {
        color: #6236ff;
        margin-right: 3px;
        font-weight: bold;
        font-size: 12px;
      }
    }

    .focus-btn-active {
      background: #f7f7f7;
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
    }
  }

  .d-text {
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    color: rgba(0, 0, 0, 0.8);
    line-height: 22px;
    margin-bottom: 16px;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  .image-container {
    position: relative;
    margin-bottom: 4px;

    .image-list {
      display: flex;
      flex-wrap: wrap;
      align-items: center;

      .image-item {
        width: 100px;
        height: 100px;
        object-fit: cover;
        margin-right: 5px;
        margin-bottom: 5px;
        border-radius: 4px;
        overflow: hidden;
      }

      .image-item:nth-child(3n) {
        margin-right: 0px;
      }

      .image-item-one {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 240px;
      }
    }

    .image-num {
      position: absolute;
      right: 0;
      bottom: 5px;
      width: 30px;
      height: 30px;
      background: rgba(0, 0, 0, 0.8);
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 30px;
      text-align: center;
    }
  }

  .tag-list {
    display: flex;
    flex-wrap: wrap;

    .tag-item {
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: #6236ff;
      line-height: 17px;
      margin-right: 10px;
    }

    .tag-item:last-child {
      margin-right: 0px;
    }
  }

  .operate-list {
    display: flex;
    align-items: center;

    .operate-item {
      margin-right: 18px;
      font-size: 10px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: rgba(56, 61, 72, 0.5);
      line-height: 14px;

      .iconfont {
        color: rgba(203, 203, 203, 1);
        font-size: 14px;
        margin-right: 8px;
      }
    }

    .operate-item:last-child {
      margin-right: 0;
    }

    .operate-item-active {
      .iconfont {
        color: rgb(240, 70, 70);
      }
    }
  }
}
</style>
